import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { useFormCreateStocks } from '../../controllers/Stocks/CreateStocksController';
import LoadingScreen from '../../components/LoadingScreen';
import { Toast } from 'primereact/toast';
import { AutoComplete } from 'primereact/autocomplete';
import classNames from 'classnames';
import { useListUnitysController } from 'src/controllers/Unitys/ListUnitysController';
import { useHistory } from 'react-router-dom';

interface filteredFieldProps {
	label: string;
	value?: string;
}

const StockForm: React.FC = () => {
	const { getStockFormController, handleStockFormController } = useFormCreateStocks();
	const { getUnityListController } = useListUnitysController();

	const [valueUnity, setValueUnity] = useState('');
	const [filteredUnity, setFilteredUnity] = useState<filteredFieldProps[]>([{ label: '', value: '' }]);

	const [registerFinished, setRegisterFinished] = useState(false);

	const history = useHistory();

	useEffect(() => {
		if (getStockFormController.stockResponse?.status === 200) {
			setRegisterFinished(true);
		}
		if (getStockFormController.stockEditedResponse?.status === 200 && !getStockFormController.stockResponse) {
			setRegisterFinished(false);
			setValueUnity('');
		}
	}, [getStockFormController.stockResponse, getStockFormController.stockEditedResponse]);

	const unitys = getUnityListController.UnitysData.map(unity => {
		return { label: unity.NOME, value: unity.ID };
	});

	const searchUnitys = (event: any) => {
		let filteredUnitys;

		if (!event.query.trim().length) {
			filteredUnitys = [...unitys];
		} else {
			filteredUnitys = unitys.filter(unity => {
				return unity.label.toLowerCase().includes(event.query.toLowerCase());
			});
		}

		setFilteredUnity(filteredUnitys);
	};

	return (
		<div style={{ height: '100%' }} className='p-grid p-align-center p-justify-center'>
			<Toast ref={getStockFormController.toast} />
			{getStockFormController.loading ? <LoadingScreen color='#0388e5' /> : <></>}
			<div className='p-col-12 p-md-8'>
				<div className='card p-fluid'>
					<h5>Estoque</h5>
					<div className='p-field'>
						<label htmlFor='name'>Nome</label>
						<InputText
							disabled={registerFinished}
							id='name'
							type='text'
							value={getStockFormController.formik.values.NOME}
							onChange={getStockFormController.formik.handleChange('NOME')}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getStockFormController.formik.touched.NOME &&
									getStockFormController.formik.errors.NOME,
								'popup-form-inactive': !(
									getStockFormController.formik.touched.NOME &&
									getStockFormController.formik.errors.NOME
								),
							})}>
							{getStockFormController.formik.errors.NOME}
						</div>
					</div>
					<div className='p-field'>
						<label htmlFor='unidade'>Unidade</label>
						<AutoComplete
							disabled={registerFinished}
							id='unidade'
							value={valueUnity}
							field='label'
							placeholder='Buscar...'
							onChange={e => {
								setValueUnity(e.value);
								getStockFormController.formik.setFieldValue(
									'ORGAOUNIDADE',
									filteredUnity.find(unity => {
										return valueUnity.toLowerCase() === unity.label.toLowerCase();
									})?.value || '',
								);
							}}
							onSelect={e => {
								setValueUnity(e.value.label);
								getStockFormController.formik.setFieldValue('ORGAOUNIDADE', e.value.value);
							}}
							suggestions={filteredUnity}
							completeMethod={searchUnitys}
							dropdown
							dropdownMode='current'
							minLength={2}
							delay={80}
						/>
						<div
							className={classNames('p-invalid popup-fade', {
								'popup-form-active':
									getStockFormController.formik.touched.ORGAOUNIDADE &&
									getStockFormController.formik.errors.ORGAOUNIDADE,
								'popup-form-inactive': !(
									getStockFormController.formik.touched.ORGAOUNIDADE &&
									getStockFormController.formik.errors.ORGAOUNIDADE
								),
							})}>
							{getStockFormController.formik.errors.ORGAOUNIDADE}
						</div>
					</div>
					<div className='p-fluid p-grid p-justify-between'>
						{getStockFormController.stockResponse?.status === 200 && !registerFinished ? (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Salvar Alterações'
									onClick={() => {
										getStockFormController.formik.handleSubmit();
									}}
								/>
							</div>
						) : getStockFormController.stockResponse?.status === 200 && registerFinished ? (
							<div className='p-col-12 p-md-6 p-fluid p-grid'>
								<div className='p-col-12 p-md-5'>
									<Button
										type='button'
										label='Editar'
										onClick={() => {
											setRegisterFinished(false);
										}}
									/>
								</div>
								<div className='p-col-12 p-md-5'>
									<Button
										icon='pi pi-plus'
										type='button'
										className='p-button-success'
										label='Cadastrar novo'
										onClick={() => {
											getStockFormController.formik.resetForm();
											handleStockFormController.setStockResponse(null);
											setRegisterFinished(false);
											setValueUnity('');
										}}
									/>
								</div>
							</div>
						) : (
							<div className='p-col-12 p-md-4'>
								<Button
									type='button'
									label='Cadastrar'
									onClick={() => getStockFormController.formik.handleSubmit()}
								/>
							</div>
						)}

						<div className='p-col-12 p-md-4'>
							<Button
								type='button'
								className='p-button-secondary'
								label='Voltar para listagem'
								onClick={() => history.goBack()}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StockForm;
